import React, { useState } from 'react'
import { Button, Table, Upload, message, Input } from 'antd'
import { DownloadOutlined, ImportOutlined } from '@ant-design/icons'
import { useHistory } from 'react-router-dom'
import { client } from '@utils/client'
import { useLocalization } from '@contexts/LocalizationContext'
import PageLayout from '@layouts/PageLayout'
import { ExcelToJSON } from '@utils/excel'

const Create = () => {
  const { t } = useLocalization()
  const [payload, setPayload] = useState([])
  const [versionLabel, setVersionLabel] = useState('')
  const history = useHistory()

  const actions = {
    setPayload,
  }
  const customRequest = ({ file, onSuccess }) => {
    const xl2json = new ExcelToJSON(actions)
    xl2json.parseExcel(file)
    setTimeout(() => {
      onSuccess('ok')
    }, 0)
  }

  const handleSubmit = async () => {
    if (payload.length === 0) {
      message.warn('กรุณาอัปโหลดข้อมูลก่อน')
      return
    }
    if (!versionLabel) {
      message.warn('กรุณาใส่ชื่อเวอร์ชั่น')
      return
    }
    try {
      const data = payload.map((item) => ({
        type: 'vaccine',
        versionLabel,
        ...item,
      }))
      await client.post('/checklist', data)
      message.success('สำเร็จ')
      history.push('/vaccines')
    } catch (e) {
      message.error('ไม่สำเร็จ')
    }
  }

  const columns = [
    {
      title: t('vaccine.listScreen.column.title'),
      dataIndex: 'title',
      key: 'title',
      width: '20%',
    },
    {
      title: t('vaccine.listScreen.column.description'),
      dataIndex: 'description',
      key: 'description',
      width: '10%',
    },
    {
      title: t('vaccine.listScreen.column.detail'),
      dataIndex: 'detail',
      key: 'detail',
      width: '20%',
    },
    {
      title: t('vaccine.listScreen.column.from'),
      dataIndex: 'from',
      key: 'from',
      width: '15%',
    },
    {
      title: t('vaccine.listScreen.column.to'),
      dataIndex: 'to',
      key: 'to',
      width: '15%',
    },
    {
      title: t('vaccine.listScreen.column.priority'),
      dataIndex: 'priority',
      key: 'priority',
      width: '10%',
    },
    {
      title: t('vaccine.listScreen.column.alertMo'),
      dataIndex: 'alertMo',
      key: 'alertMo',
      width: '10%',
    },
  ]

  const data = payload

  return (
    <PageLayout
      title={t('vaccine.createScreen.title')}
      extra={[
        <div key="extra" style={{ display: 'flex' }}>
          <Button
            key="download"
            type="link"
            href={`${process.env.PUBLIC_URL}/assets/checklist-template.xlsx`}
            icon={<DownloadOutlined />}
          >
            {t('vaccine.createScreen.downloadTemplate')}
          </Button>
          <Upload accept=".xlsx" customRequest={customRequest}>
            <Button icon={<ImportOutlined />} style={{ margin: '0 10px' }}>
              {t('vaccine.createScreen.uploadExcel')}
            </Button>
          </Upload>
          <Button key="submit" type="primary" onClick={handleSubmit}>
            {t('vaccine.createScreen.submit')}
          </Button>
        </div>,
      ]}
    >
      <div>
        <Input
          value={versionLabel}
          placeholder="ชื่อเวอร์ชั่น"
          onChange={(e) => setVersionLabel(e.target.value)}
          style={{ marginBottom: 10 }}
        />
        <Table columns={columns} dataSource={data} />
      </div>
    </PageLayout>
  )
}

export default Create
